import { DefaultAvatar } from 'atoms/default-avatar';
import { prettifyPhoneNumber } from 'util';

export default function PetDetails({ animal, user }) {
  const petDetails = [];
  if (animal.breed?.value) petDetails.push(animal.breed?.value);
  if (animal.size?.value) petDetails.push(animal.size?.value);

  return (
    <>
      <DefaultAvatar
        size="small"
        avatar={animal.avatarUrls?.desktop?.small}
        className="mr-10"
      />
      <div className="flex-column">
        <p className="f13 bold">{animal.name}</p>
        <p className="f11 c-primary-purple">{petDetails.join(' • ')}</p>
        <p className="f11 c-primary-purple">
          <span>
            {user?.firstName} {user?.lastName}:{' '}
          </span>
          {user?.phone
            ? prettifyPhoneNumber({
                number: user?.phone.number,
                countryCode: user?.phone.country?.code.value,
              })
            : ''}
        </p>
      </div>
    </>
  );
}
